(() => {
  if (window.oulaiInquiryContextInstalled) return;
  window.oulaiInquiryContextInstalled = true;
  const params = new URLSearchParams(window.location.search);
  const keys = ['product', 'product_url', 'variant_id', 'sku', 'specification', 'quantity', 'unit', 'intent'];
  function safeParam(key) {
    const value = String(params.get(key) || '').trim().slice(0, 2000);
    if (key === 'intent') return ['sample', 'bulk'].includes(value) ? value : '';
    if (key === 'quantity') return /^[1-9]\d{0,8}$/.test(value) ? value : '';
    if (key === 'variant_id') return /^\d{1,20}$/.test(value) ? value : '';
    if (key === 'product_url' && value) {
      try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
    }
    return value;
  }
  function fill(field, value) {
    if (!field || !value || field.value || field.dataset.customerEdited) return;
    field.value = value;
  }
  function prefill(root = document) {
    root.querySelectorAll('form[data-oulai-inquiry-form]').forEach((form) => {
      form.querySelectorAll('[data-inquiry-param]').forEach((field) => fill(field, safeParam(field.dataset.inquiryParam)));
      const labels = form.querySelector('[data-inquiry-labels]');
      if (!labels) return;
      const text = JSON.parse(labels.textContent);
      const lines = keys.map((key) => {
        const value = safeParam(key);
        return value ? `${text[key]}: ${key === 'intent' ? text[value] : value}` : '';
      }).filter(Boolean);
      if (safeParam('product') && !safeParam('unit')) lines.push(text.unit_pending);
      fill(form.querySelector('textarea[name="contact[body]"]'), lines.join('\n'));
    });
  }
  function refreshLink(link) {
    if (link.hasAttribute('data-cart-inquiry')) return;
    const productInfo = link.closest('product-info') || Array.from(document.querySelectorAll('product-info')).find((node) => node.dataset.productId === link.dataset.productId);
    if (!productInfo || productInfo.dataset.variantPending) return;
    const current = productInfo.querySelector('[data-product-inquiry]');
    if (!current) return;
    const currentUrl = new URL(current.href, window.location.origin);
    const url = new URL(link.href, window.location.origin);
    keys.filter((key) => key !== 'intent').forEach((key) => url.searchParams.set(key, currentUrl.searchParams.get(key) || ''));
    const selected = productInfo.querySelector('[data-selected-variant]');
    if (selected) {
      const variant = JSON.parse(selected.textContent);
      if (variant) {
        url.searchParams.set('variant_id', variant.id);
        url.searchParams.set('sku', variant.sku || '');
        url.searchParams.set('specification', variant.title || '');
      } else {
        ['variant_id', 'sku', 'specification'].forEach((key) => url.searchParams.delete(key));
      }
    }
    url.searchParams.set('quantity', productInfo.querySelector('input[name="quantity"]')?.value || '1');
    url.searchParams.set('intent', link.dataset.inquiryIntent === 'sample' ? 'sample' : 'bulk');
    link.href = url.href;
  }
  function refreshAll() { document.querySelectorAll('[data-product-inquiry]').forEach(refreshLink); }
  document.addEventListener('input', (event) => {
    if (event.target.closest('form[data-oulai-inquiry-form]') && event.isTrusted) event.target.dataset.customerEdited = 'true';
    if (event.target.closest('product-info') && event.target.name === 'quantity') refreshAll();
  });
  document.addEventListener('change', (event) => {
    if (event.target.closest('form[data-oulai-inquiry-form]') && event.isTrusted) event.target.dataset.customerEdited = 'true';
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-inquiry]');
    if (!link) return;
    const info = link.closest('product-info') || Array.from(document.querySelectorAll('product-info')).find((node) => node.dataset.productId === link.dataset.productId);
    if (info?.dataset.variantPending) {
      event.preventDefault();
      info.querySelector('[data-variant-status]')?.removeAttribute('hidden');
      return;
    }
    refreshLink(link);
  });
  document.addEventListener('oulai:variant-ready', refreshAll);
  document.addEventListener('shopify:section:load', (event) => { prefill(event.target); refreshAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { prefill(); refreshAll(); });
  else { prefill(); refreshAll(); }
})();
